import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import Root from './root.component';
// We must use a require() or WebPack will not compile this file as
// this package will be supplied at runtime
// eslint-disable-next-line @typescript-eslint/no-var-requires
const appStatePkg = require('@alinta-digital/myaccount-frontend-api-appstate');

const appState = appStatePkg.getAppState();

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function myMount(props: any) {
  const urlParams = new URLSearchParams(window.location.search);
  //hide navbar menu items for Account selection error page
  const hideNavBarItems = urlParams.get('errorType') === 'accountselectionerror';

  appState.setPropertyPage(hideNavBarItems);
  appState.setDisplayFooter(true);
  return lifecycles.mount(props);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function myUnMount(props: any) {
  // Set this back as it will have been set by the error component based on the props
  appState.setDisplayFooter(false);
  return lifecycles.unmount(props);
}

export const { bootstrap, mount, unmount } = {
  bootstrap: lifecycles.bootstrap,
  mount: myMount,
  unmount: myUnMount
};
